import React from 'react';
import {useParams} from 'react-router-dom'
import {ReactComponent as PlayIcon} from '../../svgs/play.svg';
import {ReactComponent as HeartIcon} from '../../svgs/heart.svg';
import {ReactComponent as DotIcon} from '../../svgs/dot.svg';
import {ReactComponent as NoteIcon} from '../../svgs/note.svg';

const PlaylistPage = () => {
  let { id } = useParams()
   
  return (
    <div className="playlistPage">
      <div className="mainInner">

      <div className="playlistPageInfo">
        <div className="playlistPageImage">
          <img src='https://images.unsplash.com/photo-1696347284654-b952434231e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMTl8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=900&q=60' />
        </div>
         <div className="playlistPageContent">
          <p className="smallText uppercase bold">Playlist</p>
         <h1>A Perfect Day</h1>
        
        <p className='tagline'>minimalism, electronics and modern classical to concentrate to.</p>
        <div className="playlistPageDesc">
            <h4>Spotify</h4>
            <span>699,428 likes</span>
            <span>4hr 35 min</span>
          </div>
        
         </div>
      </div>
      <div className="playlistPageSongs">
        <div className="playlistButtons">

        <span className="playIcon">
          <PlayIcon />
          </span>
        <div className="icons">
         <div className="icon iconsHeart">
         <HeartIcon />
         </div>
         {/* <div className="icon iconsDots">
         <DotIcon />
         </div> */}
        </div>
        </div>


        <ul className='songLists'>
          <li>
            <div className="songIcon">
              <NoteIcon className='noteI'/>
              <PlayIcon className='playI'/>
            </div>
            <div className="songDetails">
            <h3>Mr Man</h3>
            <span>Fave</span>
            </div>
            <div className="songTime">
            <span>4:07</span>
            </div>
            
          </li>
          <li>
          <div className="songIcon">
          <NoteIcon className='noteI'/>
          <PlayIcon className='playI'/>
            </div>
            <div className="songDetails">
            <h3>Superstar</h3>
            <span>Wizkid</span>
            </div>
            <div className="songTime">
            <span>3:07</span>
            </div>
          </li>
          
          <li>
            <div className="songIcon">
            <NoteIcon className='noteI'/>
            <PlayIcon className='playI'/>
            </div>
            <div className="songDetails">
            <h3>Calm Down</h3>
            <span>Rema</span>
            </div>
            <div className="songTime">
            <span>4:07</span>
            </div>
            </li>

          <li>
          <div className="songIcon">
          <NoteIcon className='noteI'/>
          <PlayIcon className='playI'/>
            </div>
            <div className="songDetails">
            <h3>City Boys</h3>
            <span>Burna Boy</span>
            </div>
            <div className="songTime">
            <span>4:07</span>
            </div>
          </li>
          <li>
          <div className="songIcon">
          <NoteIcon className='noteI'/>
          <PlayIcon className='playI'/>
            </div>
            <div className="songDetails">
            <h3>Men Mount</h3>
            <span>Shalipoppi</span>
            </div>
            <div className="songTime">
            <span>4:07</span>
            </div>
          </li>
        </ul>
      </div>
      </div>
      </div>
      
  )
}

export default PlaylistPage